import React from 'react';
import ReactSelect from 'react-select';
import { seasonNamesMap } from '../../../utils/contracting-preset-names-codes';
import moment from 'moment';

const SelectSeasonName = ({
  labelNode,
  style,
  onChange,
  selectedSeasonName,
  contractingPeriod,
  existingSeasons,
}) => {
  const existingSeasonNames = existingSeasons.map(season => season.seasonName);
  const hasExistingSeason = Boolean(existingSeasons && existingSeasons.length);
  const contractingPeriodString = `${moment.utc(contractingPeriod.startDate).format('D MMM YYYY')} - ${moment.utc(contractingPeriod.endDate).format('D MMM YYYY')}`;
  const systemSeasons = [
    ...Object.keys(seasonNamesMap),
  ]
  .filter(x => x)
  .map(name => ({
    seasonName: name,
    dateRanges: name === contractingPeriodString || 'All Year' && !hasExistingSeason ? [{ seasonStartDate: contractingPeriod.startDate, seasonEndDate: contractingPeriod.endDate }] : [],
  }));
  const returnOption = (season) => ({
    color: (() => {
      if (season.seasonName === selectedSeasonName) return '#ff4081';
      return 'black';
    })(),
    label: season.seasonName,
    value: season.seasonName,
    disabled: (() => {
      if (season.seasonName === 'Special Event') return false; // always enable Special Event option
      return season.seasonName && existingSeasonNames.indexOf(season.seasonName) > -1;
    })(),
  });
  const menuOptions = [
    ...(systemSeasons.map(returnOption)),
  ].filter(x => x);
  return (
    <div style={style}>
      {labelNode || <label style={{ display: 'block', margin: '0 0 8px 4px' }}>Season Name</label>}
      <ReactSelect
        clearable={false}
        options={menuOptions}
        value={selectedSeasonName}
        placeholder={selectedSeasonName}
        optionRenderer={option => <span style={{ color: option.disabled ? 'rgba(0, 0, 0, 0.33)' : option.color, fontWeight: option.bold ? 'bold' : 'normal' }}>{option.label}</span>}
        onChange={({ value }) => onChange(value)}
      />
    </div>
  );
};

export default SelectSeasonName;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/select-season-name.jsx